// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-1p8gQ"};